import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AbTestEditModel } from "@playcharge/common/models/backend/ab-tests/ab-test-edit-model";
import { AbTestViewModel } from "@playcharge/common/models/backend/ab-tests/ab-test-view-model";
import { Observable } from "rxjs";
import { ApiRoutes } from "../models/constants/api-routes";
import { ApiUtils } from "../utils/api-utils";

@Injectable({
    providedIn: "root",
})
export class ApiAbTestsService {
    private _httpClient = inject(HttpClient);

    public getTests(): Observable<AbTestViewModel[]> {
        return this._httpClient.get<AbTestViewModel[]>(ApiUtils.buildUrl(ApiRoutes.abTests.root));
    }

    public getTestById(abTestId: number): Observable<AbTestViewModel> {
        return this._httpClient.get<AbTestViewModel>(
            ApiUtils.buildUrl(
                ApiRoutes.abTests.abTest,
                new Map<string, string>([["abTestId", abTestId.toString()]]),
            ),
        );
    }

    public createTest(model: AbTestEditModel): Observable<AbTestViewModel> {
        return this._httpClient.post<AbTestViewModel>(
            ApiUtils.buildUrl(ApiRoutes.abTests.root),
            model,
        );
    }

    public updateTest(model: AbTestEditModel): Observable<AbTestViewModel> {
        return this._httpClient.put<AbTestViewModel>(
            ApiUtils.buildUrl(ApiRoutes.abTests.root),
            model,
        );
    }
}
